import { DateTime } from 'luxon';

import formatDate from './date';

export default function (value, locale) {
    return formatDate(value, DateTime.DATE_SHORT, locale);
}
